import { apiResourceUrl } from "@ploy-lib/core";
import { Resource } from "@rest-hooks/rest";
class ApplicationResource extends Resource {
    pk() {
        return this.applicationNumber || "";
    }
}
ApplicationResource.urlRoot = apiResourceUrl("applications");
export { ApplicationResource };
//# sourceMappingURL=ApplicationResource.js.map